/**
 * Invite API error copy
 *
 * The invite endpoints answer failures as `{ success: false, error, code }`. The message is
 * written for a log; these are written for the person holding the link. Anything unmapped falls
 * back to the server's own message, which is always safe to show.
 */

const INVITE_ERROR_MESSAGES: Record<string, string> = {
  // POST /api/invite/accept (409 / 410 / 404 / 400)
  ALREADY_REFERRED: 'Your account is already linked to someone else’s invite.',
  INVITE_NOT_FOUND: 'We could not find that invite. Check the link and try again.',
  INVITE_EXPIRED: 'This invite has expired. Ask for a fresh link.',
  INVITE_UNAVAILABLE: 'This invite has already been used.',
  INVITE_SELF: 'You cannot accept your own invite.',

  // Shared across the invite routes
  AUTHENTICATION_REQUIRED: 'Sign in to manage your invites.',
  AUTHENTICATION_ERROR: 'Sign in to manage your invites.',
  VALIDATION_ERROR: 'Some of those details were not valid.',
  INVITE_LINK_CREATE_ERROR: 'We could not create an invite link. Try again in a moment.',
  INVITE_EMAIL_SEND_ERROR: 'We could not send those invites. Try again in a moment.',
  INVITE_REVOKE_ERROR: 'We could not revoke that invite. Try again in a moment.',
  INVITE_DASHBOARD_ERROR: 'We could not load your invites. Try again in a moment.',
};

/**
 * Turn an API error code into copy for the user, preferring a known code over the raw message.
 */
export function describeInviteError(
  code: string | undefined,
  serverMessage: string | undefined,
  fallback: string,
): string {
  if (code && INVITE_ERROR_MESSAGES[code]) return INVITE_ERROR_MESSAGES[code];
  return serverMessage || fallback;
}
